import { useEffect, useRef } from 'react';
import { dispatcher } from 'dispatcher';
import { prop } from 'ramda';

import { usePageSelector } from 'js/store/hooks';
import { useSetQuery } from 'js/app/hooks/query/useSetQuery';
import { useQueryObject } from 'js/app/hooks/query/useQueryObject';
import { useScrollToComponent } from 'js/app/hooks/useScrollToComponent';
import { EVENT_GAME_CHANGE_SCROLL } from 'js/app/components/main/Games/constants';
import { useIsPageFullLoaded } from 'js/components/system/Page/buzz/hooks/useIsPageFullLoaded';
import {
    EVENT_UPDATE_DOM,
    WAITING_UPDATE_DOM,
    DELAY_SCROLL_TO_PARAGRAPH
} from 'js/components/system/Page/buzz/constants';

export const useScrollToParagraph = () => {
    const isOnce = useRef(false);
    const setQuery = useSetQuery();
    const queryParams = useQueryObject();
    const scrollToItem = useScrollToComponent();
    const isPageFullLoaded = useIsPageFullLoaded();
    const webContentLoadings = usePageSelector(prop('webContentLoadings'));

    useEffect(() => {
        const { p: paragraph, ...otherParams } = queryParams;

        if (!paragraph || !isPageFullLoaded) {
            return;
        }

        isOnce.current = true;
        setQuery(otherParams);

        const scrollToElement = () => {
            const targetElement = document.getElementById(paragraph);

            if (!targetElement) {
                return;
            }

            if (!isOnce.current) {
                scrollToItem({ current: targetElement });
                return;
            }

            return setTimeout(() => {
                scrollToItem({ current: targetElement });
            }, DELAY_SCROLL_TO_PARAGRAPH);
        };

        const timerScrollId = scrollToElement();

        if (!timerScrollId) {
            dispatcher.listen(EVENT_UPDATE_DOM, scrollToElement);
        }

        dispatcher.listen(EVENT_GAME_CHANGE_SCROLL, scrollToElement);

        setTimeout(() => {
            dispatcher.removeListener(EVENT_UPDATE_DOM, scrollToElement);
            dispatcher.removeListener(EVENT_GAME_CHANGE_SCROLL, scrollToElement);
        }, WAITING_UPDATE_DOM);
    }, [isPageFullLoaded, queryParams, scrollToItem, setQuery, webContentLoadings]);
};
